<template>
  <v-card
    :width="$vuetify.breakpoint.mdAndUp?'550':''"
    :max-width="$vuetify.breakpoint.smAndDown?'550':''"
    class="py-5"
    :class="[$vuetify.breakpoint.mdAndUp?'px-10':'']"
    flat
  >
    <v-form v-model="valid" ref="form">
      <v-card-text>
        <!-- Name -->
        <v-text-field
          v-model="name"
          ref="name"
          type="text"
          :rules="[() => !!name || 'This field is required']"
          :error-messages="errorMessages"
        >
          <template v-slot:label>
            Name <span class="red--text">*</span>
          </template>
        </v-text-field>

        <!-- Email Address -->
        <v-text-field
          v-model="emailAddress"
          ref="emailAddress"
          type="text"
          :rules="[() => !!emailAddress || 'This field is required']"
          :error-messages="errorMessages"
        >
          <template v-slot:label>
            Email Address <span class="red--text">*</span>
          </template>
        </v-text-field>

        <!-- Contact Number -->
        <v-text-field
          v-model="contactNumber"
          ref="contactNumber"
          :rules="[() => !!contactNumber || 'This field is required']"
          :error-messages="errorMessages"
        >
          <template v-slot:label>
            Contact Number <span class="red--text">*</span>
          </template>
        </v-text-field>

        <!-- Job Title -->
        <!-- <v-text-field
          v-model="jobTitle"
          ref="jobTitle"
          :rules="[() => !!jobTitle || 'This field is required']"
          :error-messages="errorMessages"
        >
          <template v-slot:label>
            Job Title <span class="red--text">*</span>
          </template>
        </v-text-field> -->
        <job-select-box
          v-model="jobTitle"
          ref="jobTitle"
          :rules="[() => !!jobTitle || 'This field is required']"
          :error-messages="errorMessages"
          item-value="title"
          item-text="title"
          label="Job Title *"
        >
        </job-select-box>

        <v-file-input
          accept=".pdf,.docx,.doc"
          label="File input"
          v-model="file"
          :rules="[() => !!file || 'This field is required']"
          :error-messages="errorMessages"
        >
        <!-- accept="application/pdf,application/doc,application/docx" -->
          <template v-slot:label>
            File input <span class="red--text">*</span>
          </template>
        </v-file-input>
      </v-card-text>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        tile
        depressed
        large
        color="#9faebc"
        dark
        class="my-4 mx-auto"
        width="40%"
        :loading="loading"
        @click="submit()"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Repository from "@/api/repositories";
const FormEmailApi = Repository.get("formEmails");

const JobSelectBox = () => import("./JobSelectBox");

export default {
  components: {
    JobSelectBox
  },
  data: () => ({
    valid: false,
    name: null,
    emailAddress: null,
    contactNumber: null,
    loading: false,
    file: null,
    errorMessages: '',
    jobTitle: null
  }),
  methods: {
    async submit() {
      let valid = this.$refs.form.validate();
      
      if (valid) {
        let key = "apply-now";
        let data = {
          name: this.name,
          emailAddress: this.emailAddress,
          contactNumber: this.contactNumber,
          jobTitle: this.jobTitle
        };

        console.log(this.file);
        let form = new FormData();

        form.append("key", key);
        form.append("data", JSON.stringify(data));
        form.append("file", this.file);
          
        await FormEmailApi.applyNow(form)
        .then(() => {
          // console.log({ response })
          // this.name = null;
          // this.emailAddress = null;
          // this.file = null;
          // this.contactNumber = null;
          location.reload();
        })
        .catch(error => {
          console.log({ error })
        });
      }
    }
  }
};
</script>